<template>
	<div class="m-l-50 m-t-0 w-1200">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="报销事由" prop="reason">
        <el-input v-model.trim="form.reason" type="textarea" placeholder="请输入报销事由" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input v-model.trim="form.remarks" type="textarea" placeholder="请输入备注" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="消费事由" prop="consume_reason">
        <el-input v-model.trim="form.consume_reason" type="textarea" placeholder="请输入消费事由" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="消费金额" prop="consume_money">
        <el-input v-model.number="form.consume_money" placeholder="请输入消费金额" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="消费时间" prop="consume_time">
        <el-date-picker
          class="h-40 w-400"
          v-model="form.consume_time"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="选择城市" prop="consume_city">
          <el-cascader
            placeholder="试试搜索：北京"
            class="w-400"
            :options="city_list"
            filterable
            v-model="form.consume_city">
          </el-cascader>
        </el-form-item>
      <el-form-item label="票据类型" prop="cost">
        <el-select v-model="form.cost" class="h-40 w-400" placeholder="请选择">
          <el-option
            v-for="item in cost_list"
            :key="item.cost_name"
            :label="item.cost_name"
            :value="item.cost_name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发票文件">
        <img style="width:100px;height: 100px;margin-top:6px;" :src='form.bill_url'>
        <el-upload
        :action="uploadUrl"
        type="drag"
        :thumbnail-mode="true"
        :on-preview="viewPic"
        :on-remove="handleRemove"
        :on-success="uploadSuccess"
        :on-error="uploadFail"
        :default-file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-dragger__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">保 存</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
		</el-form>
	</div>
</template>
<style>
	.form-checkbox:first-child{
		margin-left: 15px;
	}
  .item {
    margin: 4px;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  export default {
    data() {
      return {
        isLoading: false,
        fileList: [],
        propsImg: '',
        id: null,
        cost_list: [],
        city_list: [],
        form: {
          reason: '',
          remarks: '',
          consume_reason: '',
          consume_money: '',
          consume_time: '',
          cost: '',
          consume_city: '',
          bill_url: ''
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名' }
          ]
        }
      }
    },
    methods: {
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/bill/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      uploadSuccess(res, file, fileList) {
        this.form.bill_url = res.data
        let data = {
          name: '图片',
          url: window.HOST + res.data
        }
        if (this.fileList.length) {
          this.fileList[0] = data
        } else {
          this.fileList.push(data)
        }
      },
      uploadFail(err, res, file) {
        console.log('err = ', _g.j2s(err))
        console.log('res = ', _g.j2s(res))
      },
      handleRemove(file, fileList) {
        console.log('file = ', file)
        console.log('fileList = ', fileList)
      },
      viewPic() {
        this.propsImg = this.fileList[0].url
        this.$refs.preview.open()
      },
      async getCompleteData() {
        this.apiGet('admin/bill/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            this.form.reason = data.reason
            this.form.remarks = data.remarks
            this.form.consume_reason = data.consume_reason
            this.form.consume_money = data.consume_money
            this.form.consume_time = data.consume_time
            this.form.cost = data.cost
            this.form.consume_city = data.consume_city
            this.form.bill_url = data.bill_url
            this.cost_list = data.cost_list
            this.city_list = data.city_list
          })
        })
      }
    },
    created() {
      this.uploadUrl = window.HOST + 'qiniu'
      this.id = this.$route.params.id
      this.getCompleteData()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?4b889c20